import { Button } from '@/components/ui/button'

interface Props {
  onClick: () => void
  type?: 'submit' | 'button'
  className?: string
  text: string
  disabled?: boolean
  isLoading?: boolean
  variant?:
    | 'default'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | 'link'
    | null
    | undefined
}
export const ButtonPrimary = ({
  onClick,
  text,
  type,
  className,
  disabled,
  variant,
  isLoading = false,
}: Props) => {
  return (
    <Button
      className={className}
      disabled={disabled}
      onClick={onClick}
      type={type ?? 'button'}
      variant={variant ? variant : 'default'}
    >
      {isLoading ? 'Cargando...' : text}
    </Button>
  )
}
